import { useState, useEffect } from 'react';

export interface SiteFlags {
  MAINTENANCE_MODE: boolean;
  DISABLE_LOGGING: boolean;
}

const DEFAULT_FLAGS: SiteFlags = {
  MAINTENANCE_MODE: false,
  DISABLE_LOGGING: false,
};

let cachedFlags: SiteFlags | null = null;
let fetchPromise: Promise<SiteFlags> | null = null;

async function loadFlags(): Promise<SiteFlags> {
  try {
    const res = await fetch('/api/flags', { cache: 'no-store' });
    if (!res.ok) return DEFAULT_FLAGS;
    const data = await res.json();
    cachedFlags = { ...DEFAULT_FLAGS, ...data } as SiteFlags;
    return cachedFlags;
  } catch {
    return DEFAULT_FLAGS;
  }
}

/** Fetch site-wide flags once, share across all consumers. */
export function useFlags(): SiteFlags {
  const [flags, setFlags] = useState<SiteFlags>(cachedFlags ?? DEFAULT_FLAGS);

  useEffect(() => {
    if (cachedFlags) return;
    if (!fetchPromise) fetchPromise = loadFlags();
    fetchPromise.then(f => setFlags(f));
  }, []);

  return flags;
}
